import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const CreateProposal = () => {

  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [entities, setEntities] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [formData, setFormData] = useState({
    id_entidad: "",
    type_population: "",
    object: "",
    department: [],
    municipality: "",
    start_date: "",
    end_date: "",
    presupuesto_entity: "",
    presupuesto_presencia: ""
  });

  const [files, setFiles] = useState({
    doc_contratante: null,
    doc_propuesta_presencia: null,
    doc_evaluacion_propuesta: null
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ===============================
  // CARGAR ENTIDADES
  // ===============================

  useEffect(() => {

    const fetchEntities = async () => {

      try {

        const res = await authFetch(ENDPOINTS.getEntityActive);

        if (res.success) {
          setEntities(res.entidades);
        }

      } catch (err) {
        console.error("Error cargando entidades", err);
      }

    };

    fetchEntities();

  }, [authFetch]);

  // ===============================
  // CARGAR DEPARTAMENTOS
  // ===============================

  useEffect(() => {

    const fetchDepartments = async () => {

      try {

        const res = await authFetch(ENDPOINTS.getDepartmentCol);

        if (res.success) {
          setDepartments(res.data);
        }

      } catch (err) {
        console.error("Error cargando departamentos", err);
      }

    };

    fetchDepartments();

  }, [authFetch]);

  // ===============================
  // INPUTS
  // ===============================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  // ===============================
  // DEPARTAMENTOS MULTIPLE
  // ===============================

  const handleDepartmentChange = (e) => {

    const selected = Array.from(
      e.target.selectedOptions,
      option => option.value
    );

    setFormData({
      ...formData,
      department: selected
    });

  };

  // ===============================
  // ARCHIVOS
  // ===============================

  const handleFileChange = (e) => {

    const { name, files: file } = e.target;

    if (!file[0]) return;

    const allowed = ["application/zip", "application/x-zip-compressed"];

    if (!allowed.includes(file[0].type)) {
      alert("Solo se permiten archivos ZIP");
      return;
    }

    setFiles({
      ...files,
      [name]: file[0]
    });

  };

  // ===============================
  // SUBMIT
  // ===============================

const handleSubmit = async (e) => {

  e.preventDefault();

  setError("");
  setSuccess("");

  // Validaciones
  if (!formData.id_entidad) {
    setError("Debe seleccionar una entidad.");
    return;
  }

  if (!formData.type_population) {
    setError("Debe seleccionar el tipo de población.");
    return;
  }

  if (!formData.object) {
    setError("Debe ingresar el objeto.");
    return;
  }

  if (formData.department.length === 0) {
    setError("Debe seleccionar al menos un departamento.");
    return;
  }

  if (!formData.municipality) {
    setError("Debe ingresar los municipios.");
    return;
  }

  if (!formData.start_date || !formData.end_date) {
    setError("Debe seleccionar las fechas.");
    return;
  }

  try {

    const data = new FormData();

    // Campos normales
    data.append("id_entidad", formData.id_entidad);
    data.append("type_population", formData.type_population);
    data.append("object", formData.object);
    data.append("municipality", formData.municipality);
    data.append("start_date", formData.start_date);
    data.append("end_date", formData.end_date);

    data.append("presupuesto_entity", formData.presupuesto_entity || 0);
    data.append("presupuesto_presencia", formData.presupuesto_presencia || 0);

    // Departamentos
    formData.department.forEach(dep => {
      data.append("department[]", dep);
    });

    // Archivos
    if (files.doc_contratante) {
      data.append("doc_contratante", files.doc_contratante);
    }

    if (files.doc_propuesta_presencia) {
      data.append("doc_propuesta_presencia", files.doc_propuesta_presencia);
    }

    if (files.doc_evaluacion_propuesta) {
      data.append("doc_evaluacion_propuesta", files.doc_evaluacion_propuesta);
    }


    const res = await authFetch(
      ENDPOINTS.createProposal,
      {
        method: "POST",
        body: data
      }
    );

    if (!res.success) {
      setError(res.message);
      return;
    }

    setSuccess("Propuesta creada correctamente");

    setTimeout(() => {
      navigate("/session/mod_proyectos/proposal/proposal");
    }, 1500);

  } catch (err) {

    console.error(err);
    setError("Error en el servidor");

  }

};
// console.log("formData:", formData);

  return (

    <div className="p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center m-3">

        <h3>Crear Propuesta</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/mod_proyectos/proposal/proposal")}
        >
          <i className="bi bi-arrow-left me-1"></i>
          Volver
        </button>

      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* FILA 1 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Entidad *</label>

            <select
              name="id_entidad"
              className="form-select"
              value={formData.id_entidad}
              onChange={handleChange}
            >

              <option value="" hidden>Selecciona...</option>

              {entities.map(entity => (

                <option
                  key={entity.id_entidad}
                  value={entity.id_entidad}
                >
                  {entity.name}
                </option>

              ))}

            </select>

          </div>
        <div className="col-md-6 mb-3">

            <label>Tipo de población *</label>

            <select
            name="type_population"
            className="form-select"
            value={formData.type_population}
            onChange={handleChange}
            >

                <option value="" hidden>Selecciona...</option>
                <option value="Afrocolombiano">Afrocolombiano</option>
                <option value="Indígena">Indígena</option>
                <option value="Campesino">Campesino</option>
                <option value="Víctimas del conflicto">Víctimas del conflicto</option>
                <option value="Población vulnerable">Población vulnerable</option>
                <option value="Adulto mayor">Adulto mayor</option>
                <option value="Discapacidad">Personas con discapacidad</option>
                <option value="General">Población general</option>

            </select>

        </div>

        </div>

        {/* OBJETO */}

        <div className="mb-3">

          <label>Objeto *</label>

          <textarea
            name="object"
            className="form-control"
            rows="3"
            value={formData.object}
            onChange={handleChange}
          />

        </div>

        {/* DEPARTAMENTO Y MUNICIPIO */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Departamentos *</label>

            <select
              multiple
              className="form-select"
              onChange={handleDepartmentChange}
            >

              {departments.map(dep => (

                <option
                  key={dep.id_departamento}
                  value={dep.id_departamento}
                >
                  {dep.nombre}
                </option>

              ))}

            </select>

            <small className="text-muted">
              Mantenga presionada la tecla CTRL para seleccionar varios
            </small>

          </div>

          <div className="col-md-6 mb-3">

            <label>Municipios *</label>

            <textarea
              name="municipality"
              className="form-control"
              value={formData.municipality}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FECHAS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Fecha inicio *</label>

            <input
              type="date"
              name="start_date"
              className="form-control"
              value={formData.start_date}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Fecha fin *</label>

            <input
              type="date"
              name="end_date"
              className="form-control"
              value={formData.end_date}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* PRESUPUESTOS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Presupuesto entidad</label>

            <input
              type="number"
              name="presupuesto_entity"
              className="form-control"
              value={formData.presupuesto_entity}
              onChange={handleChange}
              min={1}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Presupuesto presencia</label>

            <input
              type="number"
              name="presupuesto_presencia"
              className="form-control"
              value={formData.presupuesto_presencia}
              onChange={handleChange}
              min={1}
            />

          </div>

        </div>

        {/* ARCHIVOS */}

        <div className="row">

          <div className="col-md-4 mb-3">

            <label>Documento contratante (ZIP)</label>

            <input
              type="file"
              name="doc_contratante"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label>Propuesta presencia (ZIP)</label>

            <input
              type="file"
              name="doc_propuesta_presencia"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label>Evaluación propuesta (ZIP)</label>

            <input
              type="file"
              name="doc_evaluacion_propuesta"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

        </div>

        <button type="submit" className="btn btn-outline-pink w-100 mt-4">
          Crear propuesta
        </button>

      </form>

    </div>

  );

};

export default CreateProposal;